var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"BCzzoXSG5RxiUhU6ZbGqB"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs"

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_DOMAIN_SENTRY_DSN,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded", // Ignore ResizeObserver loop limit exceeded errors
    "Non-Error promise rejection captured", // Ignore unhandled promise rejections that are not Error objects
    "messaging/unsupported-browser" // Ignore Firebase Messaging unsupported browser errors
  ]

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
